import { Rect } from '../../drawing';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { TextSpan } from '../../gregorio-chant/structures/TextSpan';
import { LyricsTextMeasurer } from '../LyricsTextMeasurer';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';

export class DropCap extends ChantLayoutElement {
  private _padding: number;
  private _class = ['syllable', 'syllable-1'];
  private _span: TextSpan;

  get padding(): number {
    return this._padding;
  }

  constructor(context: ChantContext, span: TextSpan) {
    super(context);
    this._padding = this._context.staffLinesInterval * 2;
    this._span = span;

    this.recalculateMetrics();
  }

  protected recalculateMetrics() {
    const fragment = this.createSingleSvgFragment();
    if (fragment) {
      LyricsTextMeasurer.instance.setElement(fragment);
      const bbox = LyricsTextMeasurer.instance.element.getBBox();
      this.bounds = Rect.create(0, 0, bbox.width, bbox.height);
    }
  }

  public performLayout(staffLeft: number, notationBounds: Rect): void {
    const spacelinestext = this._distanceConverter.lengthToPx(this._context.spacelinestext);
    this.bounds = Rect.create(
      staffLeft / 2,
      notationBounds.bottom + spacelinestext,
      this.bounds.width,
      this.bounds.height);
  }

  private createSingleSvgFragment(): SVGTextContentElement | null {
    const [spanElements] = this._span.getSvgSpan(this._context, false, { 
      adjustment: 0,
      vAdjustment: 35,
      rAdjustment: 20,
      aAdjustment: 22,
     });

    const textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    textEl.setAttribute('x', String(this.bounds.x));
    textEl.setAttribute('y', String(this.bounds.y));
    textEl.setAttribute('text-anchor', 'middle');
    textEl.setAttribute('dominant-baseline', 'text-top');
    const styleProperties = 'font-family:' + this._context.dropCapTextFont +
      ';font-size:' + this._context.dropCapTextSize + 'px' +
      ';font-kerning:normal;';
    textEl.setAttribute('style', styleProperties);

    if (this._class) {
      textEl.classList.add(...this._class);
    }

    for (const spanElement of spanElements) {
      if (spanElement) {
        textEl.appendChild(spanElement);
      }
    }

    return textEl;
  }

  public createSvgFragments(): SVGElement[] {
    const textEl = this.createSingleSvgFragment();
    if (!textEl) {
      return [];
    }
    return [textEl];
  }
}
